<div class="bolt-footer">
  <div class="bolt-container">
    <div class="bolt-footer__head">
      <div class="bolt-footer__intro">
        <div class="bolt-footer__logo">
          <bolt-logo
            color="white"
            href="/"
            type="nw-vertical"
          ></bolt-logo>
        </div>
        <div class="bolt-footer__phone">
          <span class="bolt-footer__phone__alpha">
            1-877 On Your Side
          </span>
          <span>(1-877-669-6877)</span>
        </div>
        <nav class="bolt-footer__social">
          <ul>
            <li>
              <a href="https://www.facebook.com/nationwide" rel="noopener" aria-label="Nationwide on Facebook" target="_blank">
                <bolt-icon name="facebook"></bolt-icon>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/nationwide" rel="noopener" aria-label="Nationwide on Twitter" target="_blank">
                <bolt-icon name="twitter"></bolt-icon>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/nationwide/" rel="noopener" aria-label="Nationwide on Instagram" target="_blank">
                <bolt-icon name="instagram"></bolt-icon>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/2340" rel="noopener" aria-label="Nationwide on LinkedIn" target="_blank">
                <bolt-icon name="linkedin"></bolt-icon>
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/nationwide" rel="noopener" aria-label="Nationwide on YouTube" target="_blank">
                <bolt-icon name="youtube"></bolt-icon>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    <div class="bolt-footer__body">
      <nav>
        <header><a href= "https://www.nationwide.com/personal/contact/">Contact us</a></header>
      </nav>
      <div class="bolt-footer__content">
        <p>
          Products underwritten by Nationwide Mutual Insurance Company and affiliates. Home Office: Columbus, OH. In Washington, Auto insurance is 
          underwritten by Nationwide Mutual Insurance Company and Homeowner insurance is underwritten by National General Insurance Company. Life
          Insurance and Annuities are issued by Nationwide Life Insurance Company and/or Nationwide Life and Annuity Insurance Company, Columbus, Ohio. 
          The general distributor for variable insurance products is Nationwide Investment Services Corporation, member FINRA. Subject to underwriting 
          guidelines, review and approval. Products and discounts not available to all persons in all states. © 2023 Nationwide.
        </p>
      </div>
    </div>
    <div class="bolt-footer__tail">
      <div class="bolt-footer__tagline">
        Nationwide is on your side<sup>&reg;</sup>
      </div>
      <nav>
        <ul>
          <li><a href="https://www.nationwide.com/personal/privacy-security/" rel="noopener" target="_blank">Privacy and Security</a></li>
          <li><a href="https://www.nationwide.com/personal/about-us/terms-conditions" rel="noopener" target="_blank">Terms and conditions</a></li>
          <li><a href="https://www.nationwide.com/personal/about-us/website-accessibility" rel="noopener" target="_blank">Accessibility</a></li>
          <li><a style="cursor: pointer;" onclick="truste.eu && truste.eu.clickListener()" rel="noopener" target="_blank">Do Not Sell My Personal Information</a></li>
        </ul>
      </nav>
      <div class="bolt-footer__badgeList">
        <div class="bolt-footerBadge">
          <a href="https://portal.hud.gov/hudportal/HUD?src=/program_offices/fair_housing_equal_opp" rel="noopener" target="_blank">
            <img style="width: 78px;" src="../../../assets/images/EqualHousingLender.png" alt="Equal Housing Lender" />
          </a>
        </div>
        <div class="bolt-footerBadge">
          <a href="https://privacy.truste.com/privacy-seal/validation?rid=33d56fbf-04d6-4530-8bb7-7a7f6bc358db" rel="noopener" target="_blank">
            <img src="../../../assets/images/seal.svg" alt="Trust Act" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>